export default __webpack_public_path__ + "static/media/pic77.306cf6a7.jpg";